import React from "react";
export var ItemSubtitle = function (_a) {
    var subtitle = _a.subtitle;
    return (React.createElement("p", { className: "w-full md:max-w-52 mt-2 md:mt-1 text-sm leading-5" }, subtitle));
};
//# sourceMappingURL=ItemSubtitle.js.map